import { Epc } from 'types/epc';

export function buildRawCodeFromEpc(epc: Epc): string {
  return buildRawCode(epc.productCode, epc.serialNumber, epc.lotNumber, epc.expiryDate);
}

export function buildRawCode(productCode: string, serialNumber: string, lotNumber: string, expiryDate: string): string {
  // return '01' + productCode + '17' + expiryDate + '10' + lotNumber + '|21' + serialNumber;
  return serialNumber;
}


// WEBPACK FOOTER //
// ./src/helpers/epc-helpers.ts